app.directive("textChapters", [
    "$window",
    "$timeout",
    "$rootScope",
    "utilsService",
    function ($window, $timeout, $rootScope, utilsService) {
        return {
            restrict: "EA",
            template:
                '<a href="{{ item.hash }}" class="chapter__link item" ng-repeat="item in sections track by $index" ng-class="{\'blue active\': item.active}" ng-click="goTo(item.hash)">{{ item.text }}</a>',
            scope: {
                content: "@",
                sectionSelector: "@"
            },
            link: function (scope, elm, attrs) {
                scope.debounceTimeout = 100;
                scope.sectionSelector = scope.sectionSelector || "h2";
                scope.sections = [];
                scope.firstSection = null;
                var winH = $(window).height();

                scope._getSectionTitleId = function (index) {
                    return "section-" + index;
                };

                scope._wrapSection = function (elements, index) {
                    if (elements && elements.length) {
                        elements.addClass(
                            "section-" + index + "__element"
                        );
                        elements.wrapAll(
                            $("<div>").attr(
                                "id",
                                "section-" + index + "__content"
                            )
                        );
                    }
                };

                scope.buildSections = function () {
                    $(scope.sectionSelector, scope.content).each(function (
                        index
                    ) {
                        var $section = $(this);
                        if ($section.length && $section.text().trim().length) {
                            var id = scope._getSectionTitleId(index + 1);
                            $section.attr("id", id);
                            scope.sections.push({
                                hash: "#" + id,
                                top: Math.floor($section.offset().top),
                                text: $section.text(),
                                active: false
                            });
                        }
                    });
                };

                scope.wrapSectionsContent = function () {
                    angular.forEach(scope.sections, function (section, index) {
                        var sectionElements = $(
                            "#" + scope._getSectionTitleId(index)
                        ).nextUntil("#" + scope._getSectionTitleId(index + 1));
                        scope._wrapSection(sectionElements, index);
                    });
                    var topElements = $(scope.sections[0].hash).prevUntil();
                    if (topElements && topElements.length) {
                        scope.sections.unshift({
                            hash: '#' + scope._getSectionTitleId('intro'),
                            top: 0,
                            text: 'Introduction',
                            active: false
                        });
                        scope._wrapSection(topElements, 'intro');
                    }
                };

                scope.setSectionsTop = function () {
                    angular.forEach(scope.sections, function (item) {
                        var $el = $(item.hash, scope.content);
                        if (!$el || !$el.length) {
                            return;
                        }
                        var x = $el.offset() && $el.offset().top
                            ? $el.offset().top
                            : 0;
                        item.top = Math.floor(x);
                    });
                };

                scope.activeMenu = function (hash) {
                    angular.forEach(scope.sections, function (item) {
                        item.active = item.hash == hash;
                    });
                    if ($window.history.pushState) {
                        $window.history.pushState(null, null, hash);
                    } else {
                        $window.location.hash = hash;
                    }
                };

                scope.goTo = function (hash) {
                    var $link = $('a.chapter__link[href="' + hash + '"]');
                    var target = scope.sections.filter(function (item) {
                        return item.hash == hash;
                    })[0];
                    if (!target) {
                        return;
                    }
                    $("html, body").animate({scrollTop: target.top - 80});
                };

                scope.goToHash = function () {
                    if ($window.location.hash) {
                        $timeout(function () {
                            scope.goTo($window.location.hash);
                        });
                    }
                };

                scope.onScroll = function (e) {
                    e.preventDefault();
                    var scrollTop = Math.floor(
                        $(window).scrollTop() + winH / 2.5
                    );
                    var hasActive = false;
                    angular.forEach(scope.sections, function (item) {
                        if (scrollTop > item.top) {
                            scope.activeMenu(item.hash);
                            hasActive = true;
                        }
                    });
                    if (!hasActive) {
                        scope.activeMenu();
                    }
                    $timeout(function () {
                        scope.$apply();
                    });
                };

                scope.onResize = function () {
                    scope.setSectionsTop();
                    scope.goToHash();
                    scope.firstSection = null;
                    winH = $(window).height();
                };

                scope.buildSections();

                if (scope.sections.length) {
                    $rootScope.$broadcast("directive.textChapters.hasChapters");
                } else {
                    return;
                }

                scope.wrapSectionsContent();
                scope.goToHash();

                $(window).on(
                    "resize",
                    utilsService.debounce(scope.onResize, scope.debounceTimeout)
                );
                $(window).on(
                    "scroll",
                    utilsService.debounce(scope.onScroll, scope.debounceTimeout)
                );
            }
        };
    }
]);
